import React, { useEffect, useState } from "react";
import AppLeftSideBar from "../../components/SideBar/AppLeftSideBar";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { toastSuccess } from "../../utils/toastUtils";
import { useModalContext } from "../../context/ModalContext";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import Input from "../../components/FormComponents/Input";
import Textarea from "../../components/FormComponents/Textarea";
import Button from "../../components/FormComponents/Button";

const PromptSection = () => {
  const { getUserConfirmationForDelete } = useModalContext();
  const [prompts, setPrompts] = useState([]);
  const [selectedPrompt, setSelectedPrompt] = useState({});
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const getPrompts = async () => {
    try {
      const { data } = await axiosInstance.get(`/ai/prompt`);
      setPrompts(data);
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    getPrompts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editPromptFun = (payload) => {
    setSelectedPrompt(payload);
    setIsEditModalOpen(true);
  };

  const addPrompt = async (payload) => {
    try {
      const { data, message } = await axiosInstance.post(`/ai/prompt`, payload);
      setPrompts((prevPrompts) => [...prevPrompts, data]);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsAddModalOpen(false);
    }
  };

  const handleEditPrompt = async (payload) => {
    try {
      const { message } = await axiosInstance.put(`/ai/prompt/${payload.id}`, payload);
      toastSuccess(message);
      getPrompts();
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsEditModalOpen(false);
      setSelectedPrompt({});
    }
  };

  const handleDeletePrompt = async (e, id, name) => {
    try {
      e.stopPropagation();
      const userConfirmed = await getUserConfirmationForDelete(name);
      if (!userConfirmed) return;

      const { message } = await axiosInstance.delete(`/ai/prompt/${id}`);
      toastSuccess(message);
      getPrompts();
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleStstemPromptDeleteFun = async (name) => {
    handleApiError({ response: { data: { message: `${name} is system prompt` } } });
  };

  return (
    <>
      <div className="application_container">
        <AppLeftSideBar type={"org"} />
        <div className="dashboard_outer_section">
          <div className="d_flex gap_3 mb_4">
            <Button onClick={() => setIsAddModalOpen(true)}>Add Prompt</Button>
          </div>
          <div className="prompt_container">
            <table>
              <thead>
                <tr>
                  <th className="text_start">Prompt Name</th>
                  <th className="text_start">Prompt</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {prompts.map((prompt) => (
                  <tr key={prompt.id}>
                    <td className="page_text_copy text_start">{prompt.name}</td>
                    <td className="page_text_copy text_start">{prompt.prompt}</td>
                    <td className="w_100">
                      <span className="d_flex justify_center align_center gap_3">
                        <ButtonActionIcon
                          type="edit"
                          size="md"
                          onClick={() => {
                            editPromptFun(prompt);
                          }}
                        />
                        {systemPromptArrayKey.includes(prompt.id) ? (
                          <ButtonActionIcon
                            type="delete"
                            size="md"
                            onClick={() => {
                              handleStstemPromptDeleteFun(prompt.name);
                            }}
                          />
                        ) : (
                          <ButtonActionIcon
                            type="delete"
                            size="md"
                            onClick={(e) => {
                              handleDeletePrompt(e, prompt.id, prompt.name);
                            }}
                          />
                        )}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <BuilderModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        modalName={selectedPrompt?.name || ""}
      >
        <AddAndEditModal addApplication={addPrompt} payload={{ prompt: "", name: "" }} editFlag={false} />
      </BuilderModal>
      <BuilderModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        modalName={selectedPrompt?.name || ""}
      >
        <AddAndEditModal addApplication={handleEditPrompt} payload={selectedPrompt} editFlag={true} />
      </BuilderModal>
    </>
  );
};

export default PromptSection;

const AddAndEditModal = ({ addApplication, payload = { prompt: "", name: "" }, editFlag = false }) => {
  const [applicationData, setApplicationData] = useState(payload);

  return (
    <div>
      <div className="builder_form">
        <Input
          label="Name"
          type="text"
          placeholder="Enter Prompt Name"
          name="name"
          value={applicationData?.name}
          onChange={(e) => setApplicationData({ ...applicationData, [e.target.name]: e.target.value })}
        />
      </div>
      <div className="builder_form">
        <Textarea
          label="Prompt"
          placeholder="Enter Prompt"
          name="prompt"
          value={applicationData?.prompt || ""}
          onChange={(e) => setApplicationData({ ...applicationData, [e.target.name]: e.target.value })}
          rows={4}
          cols={60}
        />
        <Button onClick={() => addApplication(applicationData)}>{editFlag ? "Edit " : "Add "} Prompt</Button>
      </div>
    </div>
  );
};

let systemPromptArrayKey = [
  "657bf9e31e71f88046a8cf33",
  "657bf9e31e71f88046a8cf34",
  "657bf9e31e71f88046a8cf35",
  "657bf9e31e71f88046a8cf36",
  "657bf9e31e71f88046a8cf37",
  "657bf9e31e71f88046a8cf38",
  "657bf9e41e71f88046a8cf39",
  "657bf9e41e71f88046a8cf3a",
  "657bf9e41e71f88046a8cf3b",
  "657bf9e41e71f88046a8cf3c",
  "657bf9e41e71f88046a8cf3d",
  "657bf9e41e71f88046a8cf3e",
  "657bf9e41e71f88046a8cf3f",
  "657bf9e41e71f88046a8cf40",
  "657fd2d2278ea26762bfb5c7"
];
